module.exports = __webpack_public_path__ + "static/media/city-elements-facilities-12-svgrepo-com.9503f35e.svg";